/**
 * @link https://documenter.getpostman.com/view/4774204/SVtPZXKk?version=latest
 */
export const Endpoints = {
    login: 'oauth/token',
    logout: 'user/logout',
    self: 'user/self',
    module_list: 'module/list',
    organization_modules: 'module/getListByOrganization',
    organization_list: 'organization/search',
    organization_list_login: 'organization/info/all',
    organization_details: 'organization',
    organization_add: 'organization/add',
    organization_edit: 'organization/edit',
    organization_delete: 'organization',
    organization_settings: 'organizationSettings/list',
    bill_pending_organization_list               : 'billPendingOrg/list',
    add_bill_pending_organization                : 'billPendingOrg/add',
    delete_bill_pending_organization             : 'billPendingOrg',
    set_restriction_message                      : 'billPendingOrg/setRestrictionMessage',
    get_restriction_message                      : 'billPendingOrg/getRestrictionMessage',
    app_update: 'organization/updateAndroidAppInfo',
    market_level_list: 'marketLevel/getMarketLevelHierarchy',
    market_mini_list: 'market/mini/list',
    market_level_details: 'marketLevel',
    market_level_add: 'marketLevel/add',
    market_level_edit: 'marketLevel/edit',
    market_level_delete: 'marketLevel',
    set_user_role_team: 'userRole/manageTeam',
    environment_config: 'assets/config.json',
    generate_export_status: 'utility/export/status',

    // dashboard
    dashboard_hit_count: 'actuator/hitCount',
    dashboard_role_wise_presence_count: 'attendance/roleWisePresenceCount',
    dashboard_market_wise_presence_count: 'attendance/marketWisePresenceCount',
    dashboard_market_role_shift_wise_presence_count: 'attendance/marketRoleShiftWisePresenceCount',
    dashboard_total_prescription_count: 'prescription/count',
    dashboard_market_wise_prescription_count: 'prescription/marketWiseCount',
    dashboard_total_dcr_count: 'doctorVisit/count',
    dashboard_total_submitted_by_dcr_count: 'doctorVisit/count/submittedBy',
    dashboard_market_wise_dcr_count: 'doctorVisit/marketWiseCount',
    dashboard_visited_doctor_count: 'doctorVisit/visitedDoctorCountByPlan',
    dashboard_planned_doctor_count: 'doctorVisitPlan/doctorCount',
    dashboard_market_wise_visited_doctor_count: 'doctorVisit/marketWiseVisitedDoctorCountByPlan',
    dashboard_market_wise_planned_doctor_count: 'doctorVisitPlan/marketWiseDoctorCount',
    dashboard_market_wise_doctor_count: 'doctor/marketWiseCount',
    dashboard_market_wise_total_doctor_count: 'doctorVisit/marketWiseDoctorCount',
    dashboard_submitted_dcr_by_user: 'doctorVisit/marketWiseUserCount',
    dashboard_total_rx_count: 'prescription/count',
    dashboard_market_wise_rx_count: 'prescription/marketWiseCount',
    dashboard_rx_captured_count: 'dashboard/getRxCapturedByCount',
    dashboard_focus_brand_wise_count: 'prescription/focusBrandWiseCount',
    dashboard_date_wise_focus_brand_count: 'prescription/focusBrandDateWiseCount',
    dashboard_brands_in_rx: 'dashboard/brandRxCount',
    dashboard_order_count: 'dashboard/dayWiseOrderSummary',
    dashboard_day_wise_user_dcr_count: 'dashboard/dayWiseDcrUserCount',
    dashboard_todays_rx_count: 'dashboard/todaysRxCountOfMarket',
    dashboard_brandwise_order_count: 'dashboard/brandWiseOrderAmount',
    dashboard_todays_rx_captured: 'dashboard/viewTodaysCapturedByCount',
    dashboard_todays_brand_in_rx_count: 'dashboard/todaysBrandInRxCount',
    dashboard_chemist_coverage_count: 'dashboard/marketWiseChemistVisitCount',
    daily_doctor_order_count: 'dashboard/dailyDoctorOrder',
    market_target_count: 'dashboard/marketSalesTarget',
    brand_dcr_count: 'dashboard/brandDcrCount',
    brand_rx_count: 'dashboard/brandRxCount',
    dashboard_dcr_count: 'dashboard/dayWiseDcrCount',
    dashboard_rx_count: 'dashboard/dayWiseRxCount',
    dashboard_chemist_visit_count: 'dashboard/dayWiseChemistVisitCount',
    dashboard_attendance_count: 'dashboard/dayWiseAttendanceCount',
    dashboard_order_amount: 'dashboard/marketWiseAmount',
    dashboard_key_value: 'keyValue/',
    dashboard_key_value_manage: 'keyValue',


    // doctor
    doctor_approve_list: 'doctorApprovalRule/list',
    doctor_approve_details: 'doctorApprovalRule',
    doctor_approve_edit: 'doctorApprovalRule/edit',
    doctor_approve_add: 'doctorApprovalRule/add',
    doctor_approve_delete: 'doctorApprovalRule',
    doctor_list: 'doctor/list',
    export_doctor_list: 'doctor/list',
    doctor_details: 'doctor',
    doctor_add: 'doctor/add',
    doctor_edit: 'doctor/edit',
    doctor_approve: 'doctor/approve',
    degree_list: 'academicDegree/list',
    degree_details: 'academicDegree',
    degree_add: 'academicDegree/add',
    degree_edit: 'academicDegree/edit',
    doctor_designation_list: 'doctorDesignation/list',
    doctor_designation_details: 'doctorDesignation',
    doctor_designation_add: 'doctorDesignation/add',
    doctor_designation_edit: 'doctorDesignation/edit',
    doctor_category_list: 'doctorCategory/list',
    doctor_category_details: 'doctorCategory',
    doctor_category_add: 'doctorCategory/add',
    doctor_category_edit: 'doctorCategory/edit',
    doctor_image_type_list: 'doctorImageType/list',
    doctor_image_type_details: 'doctorImageType',
    doctor_image_type_add: 'doctorImageType/add',
    doctor_image_type_edit: 'doctorImageType/edit',
    speciality_list: 'speciality/list',
    speciality_details: 'speciality',
    speciality_add: 'speciality/add',
    speciality_edit: 'speciality/edit',
    sub_speciality_list: 'subSpeciality/list',
    sub_speciality_add: 'subSpeciality/add',
    create_rx_from: 'api/rxFrom/manage',
    sub_speciality_edit: 'subSpeciality/edit',
    chamber_type_list: 'chamberType/list',
    chamber_type_details: 'chamberType',
    chamber_type_add: 'chamberType/add',
    chamber_type_edit: 'chamberType/edit',
    patient_type_list: 'patientType/list',
    patient_type_details: 'patientType',
    patient_type_add: 'patientType/add',
    patient_type_edit: 'patientType/edit',
    contact_type_list: 'contactType/list',
    contact_type_details: 'contactType',
    contact_type_add: 'contactType/add',
    contact_type_edit: 'contactType/edit',
    segment_list: 'segment/list',
    segment_details: 'segment',
    segment_add: 'segment/add',
    segment_edit: 'segment/edit',
    sub_segment_list: 'subSegment/list',
    sub_segment_details: 'subSegment',
    sub_segment_add: 'subSegment/add',
    sub_segment_edit: 'subSegment/edit',
    doctor_expected_product_add: 'doctorExpectedProduct/add',
    doctor_expected_product_edit: 'doctorExpectedProduct/edit',
    doctor_expected_product_delete: 'doctorExpectedProduct',
    update_expected_product: 'doctor/updateExpectedProduct',
    expected_product_list_by_doctor: 'doctorExpectedProduct/listByDoctor',
    department_list: 'instituteDepartment/list',
    department_details: 'instituteDepartment',
    department_add: 'instituteDepartment/add',
    department_edit: 'instituteDepartment/edit',
    special_day_list: 'specialDay/list',
    special_day_details: 'specialDay',
    special_day_add: 'specialDay/add',
    special_day_edit: 'specialDay/edit',
    doctor_visit_list: 'doctorVisit/list',
    doctor_visit_approve: 'doctorVisit/approve',
    doctor_visit_bulk_approve: 'doctorVisit/bulkApprove',
    doctor_visit_details: 'doctorVisit',
    doctor_visit_add: 'doctorVisit/add',
    doctor_visit_edit: 'doctorVisit/edit',
    doctor_visit_type_list: 'doctorVisitType/list',
    doctor_visit_type_details: 'doctorVisitType',
    doctor_visit_type_add: 'doctorVisitType/add',
    doctor_visit_type_edit: 'doctorVisitType/edit',
    doctor_visit_locations: 'doctorVisit/locations',
    doctor_order_details: 'doctorOrder',
    holiday_list: 'holiday/list',
    holiday_details: 'holiday',
    holiday_add: 'holiday/add',
    holiday_edit: 'holiday/edit',
    survey_doctor_list: 'doctor/surveyDoctorList',
    survey_doctor_edit: 'doctor/editSurveyDoctor',
    create_doctor_from_survey_doctor: 'doctor/createDoctorFromSurveyDoctor',
    doctor_record_list: 'doctorRecord/list',
    doctor_record_edit: 'doctorRecord/edit',
    doctor_record_add: 'doctorRecord/add',
    doctor_record_details: 'doctorRecord',
    doctor_record_upload: 'doctorRecord/upload',
    doctor_list_by_ids: 'doctor/list-by-ids',
    doctor_list_of_mpo: 'doctor/list-for-filter',
    doctor_all_list_for_filter: 'doctor/all-list-for-filter',


    // chemist
    customer_approve_list: 'chemistApprovalRule/list',
    customer_approve_add: 'chemistApprovalRule/add',
    customer_approve_edit: 'chemistApprovalRule/edit',
    customer_approve_delete: 'chemistApprovalRule',
    customer_approve_details: 'chemistApprovalRule',
    export_chemist_list: 'chemist/export',
    chemist_type_list: 'chemistType/list',
    chemist_type_details: 'chemistType',
    chemist_type_add: 'chemistType/add',
    chemist_type_edit: 'chemistType/edit',
    chemist_list: 'chemist/list',
    chemist_location_delete: 'chemist/location/delete',
    chemist_details: 'chemist',
    chemist_add: 'chemist/add',
    chemist_edit: 'chemist/edit',
    chemist_approve: 'chemist/approve',
    chemist_doctor_location: 'location/chemistAndDoctorLocation',
    customer_type_list: 'customerType/list',
    customer_type_details: 'customerType',
    customer_type_add: 'customerType/add',
    customer_type_edit: 'customerType/edit',
    customer_list: 'customer/list',
    export_customer_list: 'customer/export',
    customer_details: 'customer',
    customer_add: 'customer/add',
    customer_edit: 'customer/edit',
    user_last_locations: 'api/location-tracking/last-location',
    user_timeline_by_date: 'api/location-tracking/user-timeline-by-date',

    // user
    user_role_list: 'userRole/list',
    subordinate_sales_role_list: 'userRole/subordinateSalesRoleList',
    user_role_details: 'userRole',
    user_role_add: 'userRole/add',
    user_role_edit: 'userRole/edit',
    user_role_modules: 'module/getListForUserRole',
    user_list: 'user/list',
    accompany_list: 'userRole/visitWithList',
    export_user_list: 'user/export',
    user_details: 'user',
    change_user_status: 'user/active',
    user_add: 'user/add',
    user_edit: 'user/edit',
    user_list_by_accessible_market: 'user/listByAccessibleMarket',
    all_user_list: 'userFilter/list',
    all_user_mpo_list: 'userFilter/get-all-mpo',
    attendance_list: 'attendance/list',
    attendance_reset: 'attendance/resetApproval',
    attendance_add: 'attendance/add',
    attendance_edit: 'attendance/edit',
    attendance_user_list: 'attendance/userList',
    export_attendance_user_list: 'attendance/exportUserList',
    daily_shift_wise_attendance_list: 'attendance/dayWiseAttendanceWithShift',
    active_user_count_list: 'user/activeDayCount',
    active_user_count_export: 'user/exportActiveDayCount',
    user_location_list: 'location/userLocationList',
    user_location_list_v2: 'location/userLocationList/v2',
    user_last_location_list: 'location/getLastLocationList',
    user_last_location_list_v2: 'location/v2/getLastLocationList',
    user_last_location_list_v2_export: 'location/v2/exportLastLocation',
    device_list: 'userDevice/list',
    delete_user_device: 'userDevice',
    user_location_delete: 'user/attendanceLocation',
    weekend_request_list: 'weekend/requestList',
    edit_weekend_request: 'weekend/editRequest',
    approve_weekend_request: 'weekend/approveRequest',
    set_weekend_request: 'weekend/setWeekendForUser',
    monthly_weekend_request_list: 'api/weekendRequest/weekendRequestList',
    monthly_weekend_request_approve: 'api/weekendRequest/approve',
    leave_type_list: 'leaveType/list',
    leave_type_details: 'leaveType',
    leave_type_add: 'leaveType/add',
    leave_type_edit: 'leaveType/edit',
    leave_allocation_list: 'leaveAllocation/list',
    leave_allocation_details: 'leaveAllocation',
    leave_allocation_add: 'leaveAllocation/add',
    leave_allocation_edit: 'leaveAllocation/edit',
    leave_account_list: 'leaveAccount/list',
    leave_account_manage: 'leaveAccount/manage',
    multiple_leave_add: 'userLeave/multipleLeaveCreation',
    user_leave_dates: 'userLeave/leaveListOfUser',
    user_leave_list: 'userLeave/list',
    user_leave_details: 'userLeave',
    user_leave_add: 'userLeave/add',
    user_leave_edit: 'userLeave/edit',
    user_leave_bulk_reject: 'userLeave/rejectAllLeaves',
    user_leave_export: 'userLeave/export',
    user_leave_account: 'leaveReport/userAccountList',
    userleave_approve_list: 'leaveApprovalRule/list',
    userleave_approve_add: 'leaveApprovalRule/add',
    userleave_approve_edit: 'leaveApprovalRule/edit',
    userleave_approve_details: 'leaveApprovalRule',
    userleave_approve_delete: 'leaveApprovalRule',
    user_credit_upload: 'user/updateCreditLimit',
    user_list_by_ids: 'user/list-by-ids',


    // product
    product_line_list: 'productLine/list',
    product_line_details: 'productLine',
    product_line_add: 'productLine/add',
    product_line_edit: 'productLine/edit',
    product_price_list: 'productPriceList/list',
    product_price_list_details: 'productPriceList',
    product_price_edit: 'productPriceList/edit',
    product_price_add: 'productPriceList/add',
    product_price_details_list: 'productPriceList/catalogByPriceListId',
    product_price_details_updateProductPrice: 'productPriceList/updateProductPrice',
    product_brand_list: 'productBrand/list',
    product_brand_details: 'productBrand',
    product_brand_add: 'productBrand/add',
    product_brand_edit: 'productBrand/edit',
    product_type_list: 'productType/list',
    product_type_details: 'productType',
    product_type_add: 'productType/add',
    product_type_edit: 'productType/edit',
    therapeutic_group_list: 'therapeuticGroup/list',
    therapeutic_group_details: 'therapeuticGroup',
    therapeutic_group_add: 'therapeuticGroup/add',
    therapeutic_group_edit: 'therapeuticGroup/edit',
    generic_group_list: 'genericGroup/list',
    generic_group_details: 'genericGroup',
    generic_group_add: 'genericGroup/add',
    generic_group_edit: 'genericGroup/edit',
    product_list: 'product/list',
    product_and_competitor_product_list: 'product/productListAndCompetitorProductList',
    minified_product_list: 'prescription/userAndProductWiseRxCount/product',
    order_product_list: 'productPriceList/priceOfProducts',
    export_product_list: 'product/export',
    product_details: 'product',
    product_add: 'product/add',
    product_edit: 'product/edit',
    competitor_list: 'competitor/list',
    competitor_details: 'competitor',
    competitor_add: 'competitor/add',
    competitor_edit: 'competitor/edit',
    competitor_product_list: 'competitorProduct/list',
    competitor_product_details: 'competitorProduct',
    competitor_product_add: 'competitorProduct/add',
    competitor_product_edit: 'competitorProduct/edit',
    competitor_brand_list: 'competitorBrand/list',
    competitor_brand_add: 'competitorBrand/add',
    competitor_brand_edit: 'competitorBrand/edit',
    competitor_brand_details: 'competitorBrand',
    competitor_brand_upload: 'competitorBrand/upload',
    product_sales_target_list: 'marketProductSalesTarget/list',
    product_sales_target_details: 'marketProductSalesTarget',
    product_sales_target_add: 'marketProductSalesTarget/add',
    product_sales_target_edit: 'marketProductSalesTarget/edit',

    // prescription
    prescription_type_list: 'prescriptionType/list',
    prescription_type_details: 'prescriptionType',
    prescription_type_add: 'prescriptionType/add',
    prescription_type_edit: 'prescriptionType/edit',
    reject_reason_list: 'rxRejectReason/list',
    reject_reason_add: 'rxRejectReason/add',
    reject_reason_edit: 'rxRejectReason/edit',
    prescription_list: 'prescription/list',
    prescription_image_list: 'prescription/list/images',
    prescription_gallery_export: 'prescription/list/images/export',
    prescription_details: 'prescription',
    prescription_add: 'prescription/add',
    prescription_edit: 'prescription/edit',
    prescription_approve: 'prescription/approve',
    prescription_approve_with_rx_type: 'prescription/approveWithRxType',
    prescription_reject_with_reason: 'prescription/rejectWithReason',
    update_reason: 'prescription/updateRejectReason',
    prescription_approval_rule_list: 'rxApprovalRule/v2/list',
    add_prescription_approval_rule: 'rxApprovalRule/v2/add',
    delete_prescription_approval_rule: 'rxApprovalRule/v2',
    export_prescription_list: 'prescription/list/export',
    rx_from_list: 'api/rxFrom/',
    similar_rx_list: 'prescription/similar-rx-list',
    non_duplicate_rx_remove: 'prescription/rx-not-duplicate',

    rx_survey_type_list: 'rxSurveyType/list',
    rx_survey_type_add: 'rxSurveyType/add',
    rx_survey_type_edit: 'rxSurveyType/edit',
    rx_survey_type_details: 'rxSurveyType',

    rx_survey_list: 'rxSurvey/list',
    rx_survey_approve: 'rxSurvey/approve',
    rx_survey_edit: 'rxSurvey/edit',
    rx_survey_details: 'rxSurvey',

    // tour plan
    tourplan_approve_list: 'tourPlanApprovalRule/list',
    tourplan_approve_add: 'tourPlanApprovalRule/add',
    tourplan_approve_edit: 'tourPlanApprovalRule/edit',
    tourplan_approve_details: 'tourPlanApprovalRule',
    tourplan_approve_delete: 'tourPlanApprovalRule',
    tourplan_reset: 'tourPlan/resetStatus',
    tour_plan_user_list: 'tourPlan/plannedUserList',
    tour_plan_details: 'tourPlan',
    tour_plan_details_by_user_year_month: 'tourPlan/details',
    tour_plan_manage: 'tourPlan/manage',
    tour_plan_manage_v2: 'tourPlan/v2/manage',
    tour_plan_approve: 'tourPlan/approve',
    tour_plan_list: 'tourPlan/list',
    tour_plan_list_v2: 'tourPlan/v2/list',
    tour_type_details: 'tourType',
    tour_type_add: 'tourType/add',
    tour_type_edit: 'tourType/edit',
    tour_purpose_list: 'tourPurpose/list',
    tour_purpose_details: 'tourPurpose',
    tour_purpose_add: 'tourPurpose/add',
    tour_purpose_edit: 'tourPurpose/edit',
    tour_plan_of_a_person: 'tourPlan/planOfPerson',
    tour_plan_of_a_person_export: 'tourPlan/planOfPerson/export',
    tour_plan_market_frequency_of_a_person: 'tourPlan/planOfPerson/marketFrequency',
    tour_plan_tour_type_frequency: 'tourPlan/planOfPerson/tourTypeFrequency',

    // order
    order_approve_list: 'orderApprovalRule/list',
    order_approve_edit: 'orderApprovalRule/edit',
    order_approve_add: 'orderApprovalRule/add',
    order_approve_details: 'orderApprovalRule',
    order_approve_delete: 'orderApprovalRule',

    // invoice
    inv0ice_details: 'invoice',
    inv0ice_list: 'invoice/list',
    invoice_export: 'invoice/export',
    invoice_add: 'invoice/add',
    invoice_sync_list: 'invoice/sync/list',
    invoice_sync_details: 'invoice/sync',

    // return
    return_list: 'return/list',
    return_details: 'return',

    // delivery
    delivery_details: 'delivery',
    delivery_list: 'delivery/list',
    delivery_approve: 'delivery/approve',

    // payment
    payment_approve_list: 'paymentApprovalRule/list',
    payment_approve_details: 'paymentApprovalRule',
    payment_approve_edit: 'paymentApprovalRule/edit',
    payment_approve_add: 'paymentApprovalRule/add',
    payment_list: 'payment/list',
    payment_details: 'payment',
    payment_edit: 'payment/edit',
    payment_add: 'payment/add',
    payment_approve: 'payment/approve',

    utility_upload: 'utility/upload',


    centralStockList: 'centralStock/list',
    central_stock_add: 'centralStock/add',
    central_stock_transfer_approve: 'centralStock/transfer/approve',
    centralStock_transfer_list: 'centralStock/transfer/list',
    central_stock_transfer_details: 'centralStock/transfer',
    stock_transfer_add: 'centralStock/transfer',

    expenseclaim_approve_list: 'expenseClaimApprovalRule/list',
    expenseclaim_approve_add: 'expenseClaimApprovalRule/add',
    expenseclaim_approve_edit: 'expenseClaimApprovalRule/edit',
    expenseclaim_approve_delete: 'expenseClaimApprovalRule',
    expenseclaim_approve_details: 'expenseClaimApprovalRule',
    ta_da_approve_list: 'taDaClaimApprovalRule/list',
    ta_da_claim_approve_edit: 'taDaClaimApprovalRule/edit',
    ta_da_claim_approve_add: 'taDaClaimApprovalRule/add',


    visit_approve_list: 'visitApprovalRule/list',
    visit_approve_add: 'visitApprovalRule/add',
    visit_approve_edit: 'visitApprovalRule/edit',
    visit_approve_details: 'visitApprovalRule',
    visit_approve_delete: 'visitApprovalRule',

    survey_chemist_approve_list: 'surveyApprovalRule/listForCustomer',
    survey_chemist_approve_add: 'surveyApprovalRule/addForCustomer',
    survey_chemist_approve_edit: 'surveyApprovalRule/editForCustomer',


    survey_doctor_approve_list: 'surveyApprovalRule/listForDoctor',
    survey_doctor_approve_add: 'surveyApprovalRule/addForDoctor',
    survey_doctor_approve_edit: 'surveyApprovalRule/editForDoctor',


    survey_site_approve_list: 'surveyApprovalRule/listForSite',
    survey_site_approve_add: 'surveyApprovalRule/addForSite',
    survey_site_approve_edit: 'surveyApprovalRule/editForSite',

    survey_team_approve_list: 'surveyApprovalRule/listForTeam',
    survey_team_approve_add: 'surveyApprovalRule/addForTeam',
    survey_team_approve_edit: 'surveyApprovalRule/editForTeam',

    survey_approve_details: 'surveyApprovalRule',
    survey_approve_delete: 'surveyApprovalRule',


    route_list: 'distributionRoute/list',
    route_details: 'distributionRoute',
    route_edit: 'distributionRoute/edit',
    route_add: 'distributionRoute/add',

    bankAccount_list: 'bankAccount/list',
    bankAccount_details: 'bankAccount',
    bankAccount_edit: 'bankAccount/edit',
    bankAccount_add: 'bankAccount/add',


    payment_method_list: 'paymentMethod/list',
    payment_method_details: 'paymentMethod',
    payment_method_add: 'paymentMethod/add',
    payment_method_edit: 'paymentMethod/edit',
    transport_method_list: 'transport/list',
    transport_method_details: 'transport',
    transport_method_add: 'transport/add',
    transport_method_edit: 'transport/edit',
    survey_type_list: 'surveyType/list',
    survey_type_details: 'surveyType',
    survey_type_add: 'surveyType/add',
    survey_type_edit: 'surveyType/edit',
    monthlyAllowance_list: 'monthlyAllowance/list',
    monthlyAllowance_details: 'monthlyAllowance',
    monthlyAllowance_add: 'monthlyAllowance/add',
    monthlyAllowance_edit: 'monthlyAllowance/edit',
    sales_center_list: 'salesCenter/list',
    sales_center_details: 'salesCenter',
    sales_center_add: 'salesCenter/add',
    sales_center_edit: 'salesCenter/edit',
    sales_center_of_market: 'salesCenter/of-market',
    sales_center_list_by_ids: 'salesCenter/list-by-ids',
    market_list: 'market/list',
    export_market_list: 'market/export',
    market_list_by_distributor: 'market/operatingMarketListOnDistributor',
    market_list_by_customer: 'market/operatingMarketListOnCustomer',
    market_list_by_distributor_and_customer: 'market/operatingMarketListOnCustomerAndDistributor',
    market_details: 'market',
    market_add: 'market/add',
    market_edit: 'market/edit',
    market_delete: 'market',
    market_list_by_ids: 'market/list-by-ids',
    ma_claim_user_list: 'api/maClaim/getUserList',
    ma_claim_list: 'api/maClaim/list',
    ma_claim_generate: 'api/maClaim/generate',
    ma_claim_details: 'api/maClaim/getDetails',
    edit_ma_claim: 'api/maClaim/edit',
    role_wise_da_rule_list: 'api/v1/role-wise-daily-allowances/list',
    role_wise_da_rule_add: 'api/v1/role-wise-daily-allowances/add',
    role_wise_da_rule_update: 'api/v1/role-wise-daily-allowances/update',
    role_wise_da_rule_inactive: 'api/v1/role-wise-daily-allowances/inactiveRoleWiseDA',
    role_wise_da_rule_delete: 'api/v1/role-wise-daily-allowances/delete',
    role_wise_monthly_allowance_list: 'api/v1/role-wise-monthly-allowances/list',
    role_wise_monthly_allowance_details: 'api/v1/role-wise-monthly-allowances/getDetail',
    role_wise_monthly_allowance_add: 'api/v1/role-wise-monthly-allowances/add',
    role_wise_monthly_allowance_update: 'api/v1/role-wise-monthly-allowances/update',
    role_wise_monthly_allowance_inactive: 'api/v1/role-wise-monthly-allowances/inactive',
    role_wise_monthly_allowance_delete: 'api/v1/role-wise-monthly-allowances/delete',



    change_password: 'user/changePassword',

    expected_product_vs_return_report: 'doctor/expectedProductVsReturn',
    export_expected_product_vs_return_report: 'doctor/expectedProductVsReturn/export',
    site_type_list: 'siteType/list',
    site_type_details: 'siteType',
    ssite_type_add: 'siteType/add',
    site_type_edit: 'siteType/edit',

    site_owner_list: 'siteOwnerType/list',
    site_owner_details: 'siteOwnerType',
    ssite_owner_add: 'siteOwnerType/add',
    site_owner_edit: 'siteOwnerType/edit',

    allowed_promotion_type_list: 'allowedPromotionType/list',
    allowed_promotion_type_save: 'allowedPromotionType/add',

    stock_list: 'stock/stockOfASalesCenter',
    sample_stock_list: 'sampleStock/list',
    sample_stock_summary: 'sampleStock/summary',
    sample_stock_summary_export: 'sampleStock/exportSummary',
    sample_stock_allocation_list: 'sampleStock/allocationList',
    sample_stock_allocation_summary: 'sampleStock/allocationSummary',
    sample_stock_allocation_export: 'sampleStock/exportAllocationSummary',
    sample_stock_add: 'sampleStock/set',
    sample_stock_edit: 'sampleStock/edit',
    transfer_sample_stock: 'sampleStock/transferUserStock',
    stock_add: 'stock/set',
    stock_edit: 'stock/edit',
    distributor_route_list: 'distributionRoute/list',
    export_sample_stock_allocation_list: 'sampleStock/allocationList/export',


    monthly_expense_claim_list: 'expenseClaim/getMonthlyTaDaAndMileageOfUser',
    userrole_wise_attendance_list: 'attendance/roleWisePerDayAttendanceCountReport',
    export_daily_shift_wise_attendance_list: 'attendance/exportDayWiseAttendanceWithShift',
    export_user_role_wise_attendance_list: 'attendance/exportRoleWisePerDayAttendanceCountReport',
    attendance_registry: 'attendance/registrar',
    absent_summary: 'attendance/absentSummary',
    market_attendance: 'attendance/marketPresenceCount',
    market_wise_attended_absent_count: 'attendance/marketWiseAttendedAbsentCount',
    role_wise_absent_count: 'attendance/roleWiseAbsentCount',
    export_market_attendance: 'attendance/exportMarketPresenceCount',
    daily_status_registrar: 'attendance/dailyStatusRegistrar',
    export_attendance_registry: 'attendance/exportRegistrar',
    export_daily_status_registrar: 'attendance/exportDailyStatusRegistrar',
    attendance_status_registrar: 'attendance/v2/statusRegistrar',
    attendance_status_registrar_export: 'attendance/v2/exportStatusRegistrar',
    presence_report: 'attendance/presenceReport',
    presence_report_export: 'attendance/exportPresenceReport',
    market_doctor_product_dcr_export: 'doctorVisit/exportUserDoctorProductReport',


    export_monthly_tour_plans: 'tourPlan/exportMonthlyTourPlan',
    order_count_amount_by_user: 'orderReport/orderCountAndAmountByUser',
    export_order_count_amount_by_user: 'orderReport/exportOrderCountAndAmountByUser',
    user_rx_target_list: 'rxTarget/list',
    user_rx_target_add: 'rxTarget/add',
    user_rx_target_edit: 'rxTarget/edit',
    market_sales_target_list: 'marketSalesTarget/list',
    market_product_sales_target_list: 'marketProductSalesTarget/list',
    market_product_sales_target_list_quarter: 'marketProductSalesTarget/listOfQuarter',
    daily_target_achievement_list: 'dailySalesTarget/list',
    market_sales_target_details: 'marketSalesTarget',
    daily_sales_target_details: 'dailySalesTarget',
    market_sales_target_add: 'marketSalesTarget/add',
    market_sales_target_edit: 'marketSalesTarget/edit',
    daily_sales_target_set: 'dailySalesTarget/set',
    daily_sales_target_add: 'dailySalesTarget/add',
    daily_sales_target_edit: 'dailySalesTarget/edit',
    user_rx_target_and_count: 'rxTarget/report/rx-target-and-count',
    user_rx_target_and_count_export: 'rxTarget/report/rx-target-and-count/export',


    expense_type_list: 'expenseType/list',
    expense_type_details: 'expenseType',
    expense_type_add: 'expenseType/add',
    expense_type_edit: 'expenseType/edit',
    visit_type_list: 'visitType/list',
    visitType_details: 'visitType',
    visitType_add: 'visitType/add',
    visitType_edit: 'visitType/edit',
    visit_list: 'visit/list',
    visit_details: 'visit',
    visit_add: 'visit/add',
    visit_edit: 'visit/edit',
    visit_approve: 'visit/approve',
    expense_purpose_list: 'expensePurpose/list',
    expense_purpose_details: 'expensePurpose',
    expense_purpose_add: 'expensePurpose/add',
    expense_purpose_edit: 'expensePurpose/edit',
    expense_claim_list: 'expenseClaim/list',
    expense_claim_list_export: 'expenseClaim/export',
    expense_claim_approval: 'expenseClaim/approve',
    expense_claim_itemised_list: 'expenseClaim/itemisedList',
    expense_claim_details: 'expenseClaim',
    expense_claim_add: 'expenseClaim/add',
    expense_claim_edit: 'expenseClaim/edit',
    expense_claim_bulk_approve: 'expenseClaim/bulkApprove',
    expense_claim_reset_approval: 'expenseClaim/resetStatus',
    attendance_user_list_shifting: 'attendance/userListWithShift',
    export_attendance_user_list_shifting: 'attendance/exportUserListWithShift',
    daily_ta_da_list: 'dailyTaDa/list',
    daily_ta_da_details: 'dailyTaDa',
    daily_ta_da_details_by_user_role_market: 'dailyTaDa/details',
    daily_ta_da_manage: 'dailyTaDa/manage',
    taDaMarketRule_list: 'taDaMarketRule/list',
    user_distance_wise_ta_da_rule_list: 'userDistanceWiseTaDaRule/list',
    user_distance_wise_ta_da_rule_details: 'userDistanceWiseTaDaRule',
    user_distance_wise_ta_da_rule_add: 'userDistanceWiseTaDaRule/add',
    user_distance_wise_ta_da_rule_upload: 'userDistanceWiseTaDaRule/upload',
    user_distance_wise_ta_da_rule_edit: 'userDistanceWiseTaDaRule/edit',
    user_distance_wise_ta_da_rule_delete: 'userDistanceWiseTaDaRule',
    user_distance_wise_ta_da_rule_location_delete: 'userDistanceWiseTaDaRule',
    user_details_distance_wise_ta_da_rule_Location: 'userDistanceWiseTaDaRule/userHqLocation',
    taDaMarketRule_details: 'taDaMarketRule',
    taDaMarketRule_add: 'taDaMarketRule/add',
    taDaMarketRule_edit: 'taDaMarketRule/edit',
    ta_da_claim_list: 'taDaClaim/list',
    ta_da_claim_list_export: 'taDaClaim/export',
    ta_da_claim_details: 'taDaClaim',
    ta_da_claim_edit: 'taDaClaim/edit',
    ta_da_claim_add: 'taDaClaim/add',
    ta_da_claim_approve: 'taDaClaim/approve',
    ta_da_claim_reset_approval: 'taDaClaim/resetStatus',
    daily_ta_da_claim_list: 'dailyTaDaClaim/list',
    daily_ta_da_claim_details: 'dailyTaDaClaim',
    daily_ta_da_claim_details_by_user_market_date: 'dailyTaDaClaim/details',
    daily_ta_da_claim_add: 'dailyTaDaClaim/add',
    daily_ta_da_claim_edit: 'dailyTaDaClaim/edit',
    distributor_return_stock_list: 'distributorStock/returnStockList',
    distributor_return_stock_transaction_list: 'distributorStock/returnStockTransactionList',
    expense_claim_per_user_report: 'expenseClaim/perUserReport',
    export_expense_claim_per_user_report: 'expenseClaim/exportPerUserReport',
    tour_type_list: 'tourType/list',
    notification_list: 'systemNotification/list',

    daily_shift_list: 'dailyShift/list',
    daily_shift_details: 'dailyShift',
    daily_shift_add: 'dailyShift/add',
    daily_shift_edit: 'dailyShift/edit',
    institute_type_list: 'instituteType/list',
    institute_type_details: 'instituteType',
    institute_type_add: 'instituteType/add',
    institute_type_edit: 'instituteType/edit',
    institute_list: 'institute/list',
    institute_details: 'institute',
    institute_add: 'institute/add',
    institute_edit: 'institute/edit',


    user_dcr_calendar: 'doctorVisit/userDcrCalendar',
    doctor_wise_sample_gift_ppm_count: 'doctorVisit/doctorWiseSampleGiftPpmCount',
    export_doctor_wise_sample_gift_ppm_count: 'doctorVisit/exportDoctorWiseSampleGiftPpmCount',
    monthly_user_dcr_count: 'doctorVisit/userDcrMonthlyCount',
    plan_vs_visit_for_one_user: 'doctorVisitPlan/planVsVisitOfOneUser',
    export_plan_vs_visit_for_one_user: 'doctorVisitPlan/exportPlanVsVisitOfOneUser',
    plan_vs_visit: 'doctorVisitPlan/planVsVisit',
    export_plan_vs_visit: 'doctorVisitPlan/exportPlanVsVisit',
    user_rx_calendar: 'prescription/userRxCalendar',
    user_timeline: 'location/userLocation/timeline',
    timeline_by_date_range: 'location/userLocation/timeline/multipleDates',
    export_timeline_by_date_range: 'location/userLocation/timeline/multipleDates/export',
    user_rx_calendar_summary: 'prescription/userRxCalendarSummary',
    user_rx_export: 'prescription/exportUserRxCalendar',
    user_seen_rx: 'seenRx/userSeenRxCalendar',
    user_seen_rx_export: 'seenRx/exportUserSeenRxCalendar',
    user_rx_monthly_count: 'prescription/userRxMonthlyCount',
    user_rx_monthly_export: 'prescription/exportUserRxMonthlyCount',
    doctor_rx_monthly_count: 'prescription/doctorRxMonthlyCount',
    doctor_rx_monthly_export: 'prescription/exportDoctorRxMonthlyCount',
    doctor_rx_monthly_count_by_market: 'prescription/doctorRxMonthlyCountByMarket',
    export_doctor_rx_monthly_count_by_market: 'prescription/exportDoctorRxMonthlyCountByMarket',
    doctor_dcr_calendar: 'doctorVisit/doctorDcrCalendar',
    accompany_call_report: 'doctorVisit/accompanyCallReport',
    export_accompany_call_report: 'doctorVisit/exportAccompanyCallReport',
    doctor_market_dcr_report: 'doctorVisit/doctorMarketDcrReport',
    daily_user_dcr_report: 'doctorVisitPlan/userDailyDCRreport',
    daily_user_dcr_report_export: 'doctorVisitPlan/exportUserDailyDCRreport',
    doctor_market_dcr_report_export: 'doctorVisit/exportDoctorMarketDcrReport',
    doctor_rx_calendar: 'prescription/doctorRxCalendar',
    doctor_market_rx_count: 'prescription/doctorMarketRxReport',
    doctor_market_calender_rx_count: 'prescription/doctorMarketRxCalendar',
    doctor_market_calender_rx_count_export: 'prescription/doctorMarketRxCalendar/export',
    product_brand_dcr_calendar: 'doctorVisit/productBrandDcrCalendar',
    user_brand_dcr_report: 'doctorVisit/userBrandDcrReport',
    market_product_dcr_report: 'doctorVisit/marketWiseDcrCountByProduct',
    export_market_product_dcr_report: 'doctorVisit/marketWiseDcrCountByProduct/export',
    market_product_distribution_report: 'doctorVisit/marketWiseProductDistributionThroughDcr',
    export_market_product_distribution_report: 'doctorVisit/marketWiseProductDistributionThroughDcr/export',
    product_brand_rx_calendar: 'prescription/productBrandRxCalendar',
    market_brand_rx_calendar: 'prescription/marketBrandRxCalendar',
    market_product_rx: 'prescription/marketAndProductWiseRxCount',
    market_product_rx_export: 'prescription/marketAndProductWiseRxCount/export',
    user_brand_rx: 'prescription/userBrandRxReport',
    user_doctor_brand_report: 'doctorVisit/userDoctorBrandReport',
    dcr_comparison: 'doctorVisit/compareWithLastMonth',
    institure_calender_rx: 'prescription/instituteRxCalendar',
    institure_brand_rx: 'prescription/instituteBrandRxCount',
    export_institure_calender_rx: 'prescription/exportInstituteRxCalendarReport',
    export_institure_brand_rx: 'prescription/exportInstituteBrandRxReport',
    doctor_brand_rx: 'prescription/doctorBrandRxReport',
    doctor_wise_rx_count_by_product: 'prescription/doctorWiseRxCountByProduct',
    export_doctor_wise_rx_count_by_product: 'prescription/exportDoctorWiseRxCountByProduct',
    doctor_brand_wise_rx: 'prescription/doctorsBrandWiseRx',
    export_doctor_brand_wise_rx: 'prescription/exportDoctorsBrandWiseRx',
    market_wise_rx_share: 'rxSurvey/marketWiseRxShare',
    export_market_wise_rx_share: 'rxSurvey/exportMarketWiseRxShare',
    market_wise_rx_share_summary: 'rxSurvey/marketWiseRxShareSummary',
    market_date_wise_rx_share_with_details: 'rxSurvey/marketDateWiseRxShareWithDetails',
    export_market_date_wise_rx_share_with_details: 'rxSurvey/exportMarketDateWiseRxShareWithDetails',
    market_date_wise_rx_share_with_details_summary: 'rxSurvey/marketDateWiseRxShareWithDetailsSummary',
    user_wise_rx_count_by_rx_type: 'prescription/userWiseRxCountByRxType',
    user_wise_rx_count_by_rx_type_summary: 'prescription/userWiseRxCountByRxType/summary',
    user_wise_rx_count_by_rx_type_export: 'prescription/userWiseRxCountByRxType/export',
    product_wise_rx_survey: 'rxSurvey/productWiseRxSurvey',
    product_wise_rx_survey_summary: 'rxSurvey/productWiseRxSurveySummary',
    export_product_wise_rx_survey: 'rxSurvey/exportProductWiseRxSurvey',
    doctor_wise_rx_survey: 'rxSurvey/doctorWiseRxSurvey',
    export_doctor_wise_rx_survey: 'rxSurvey/exportDoctorWiseRxSurvey',
    doctor_wise_rx_survey_summary: 'rxSurvey/doctorWiseRxSurveySummary',
    user_wise_plan_vs_visit_report: 'doctorVisitPlan/userWisePlanVsVisitReport',
    export_user_wise_plan_vs_visit_report: 'doctorVisitPlan/exportUserWisePlanVsVisitReport',
    user_product_rx: 'prescription/userAndProductWiseRxCount',
    export_user_product_rx: 'prescription/exportUserAndProductWiseRxCount',
    doctor_wise_sample_gift_ppm_count_v2: 'doctorVisit/v2/doctorWiseSampleGiftPpmCount',
    export_doctor_wise_sample_gift_ppm_count_v2: 'doctorVisit/v2/doctorWiseSampleGiftPpmCount/export',


    seen_rx_list: 'seenRx/list',
    seen_rx_details: 'seenRx',
    seen_rx_edit: 'seenRx/edit',
    seen_rx_add: 'seenRx/add',
    seen_rx_approve: 'seenRx/approve',

    product_dcr_calendar: 'doctorVisit/productDcrCalendar',
    product_rx_calendar: 'prescription/productRxCalendar',
    segment_wise_dcr_compact: 'doctorVisit/dcrCountByProductSegment/compact',
    segment_wise_dcr_compact_total: 'doctorVisit/dcrCountByProductSegment/compact/total',
    export_segment_wise_dcr_compact: 'doctorVisit/dcrCountByProductSegment/compact/export',
    segment_wise_dcr_calender: 'doctorVisit/dcrCountByProductSegment/calendar',
    segment_wise_dcr_calender_total: 'doctorVisit/dcrCountByProductSegment/calendar/total',
    export_segment_wise_dcr_calendar: 'doctorVisit/dcrCountByProductSegment/calendar/export',
    user_rx_type_count: 'prescription/rxCountByUserAndRxType',
    market_product_doctor_dcr_report: 'doctorVisit/userDoctorProductReport',
    export_market_product_doctor_dcr_report: 'doctorVisit/exportUserDoctorProductReport',
    doctor_product_dcr_report: 'doctorVisit/summaryByDoctorProduct',
    export_doctor_product_dcr_report: 'doctorVisit/exportSummaryByDoctorProduct',
    doctor_wise_promoted_products: 'doctorVisit/report/doctor-wise-promoted-products',
    doctor_wise_promoted_products_export: 'doctorVisit/report/doctor-wise-promoted-products/export',
    notice_board_list: 'noticeBoard/listOfSubordinates',
    notice_details: 'noticeBoard',
    notice_edit: 'noticeBoard/edit',
    notice_add: 'noticeBoard/add',
    mileageClaim_list: 'mileageClaim/list',
    mileageClaim_details: 'mileageClaim',
    mileageClaim_edit: 'mileageClaim/edit',
    mileageClaim_add: 'mileageClaim/add',
    mileageClaim_approve: 'mileageClaim/approve',
    site_list: 'site/list',
    site_details: 'site',
    site_edit: 'site/edit',
    site_add: 'site/add',
    site_approve: 'site/approve',
    survey_list: 'survey/list',
    exam_list: 'exam/list',
    delete_exam: 'exam',
    exam_details: 'exam',
    exam_v2_list: 'exam/list/underMe',
    survey_details: 'survey',
    survey_add: 'survey/add',
    survey_edit: 'survey/edit',
    exam_add: 'exam/add',
    exam_edit: 'exam/edit',
    exam_response_list: 'examRespondent/list',
    exam_response_details: 'examRespondent',
    exam_evaluation_save: 'examRespondent/evaluate',
    survey_response_list: 'surveyRespondent/list',
    survey_response_approve: 'surveyRespondent/approve',

    survey_response_details: 'surveyRespondent',
    survey_response_add: 'surveyRespondent/add',
    survey_response_edit: 'surveyRespondent/edit',
    mileageClaim__reset_approval: 'mileageClaim/resetStatus',
    mileageClaim_export: 'mileageClaim/export',
    order_list_export: 'order/exportOrderList',
    market_rx_export: 'prescription/web/marketRxCalendar/export',
    training_list: 'training/listOfSubordinates',
    training_details: 'training',
    training_edit: 'training/edit',
    training_comment: 'training/comment',
    training_add: 'training/add',
    order_list: 'order/list',
    doctor_order_list: 'doctorOrder/list',
    export_doctor_order: 'doctorOrder/export',
    order_details: 'order',

    doctor_order_market_sales_summary_report: 'doctorOrder/marketSummary',
    doctor_order_product_summary_report: 'doctorOrder/productSalesSummary',
    doctor_order_product_summary_export: 'doctorOrder/exportProductSalesSummary',
    doctor_order_brand_summary_report: 'doctorOrder/brandWiseSalesSummary',
    doctor_order_brand_summary_export: 'doctorOrder/exportBrandWiseSalesSummary',
    doctor_order_sales_summary_report: 'doctorOrder/summaryReport',
    doctor_order_sales_summary_export: 'doctorOrder/exportSummaryReport',
    order_add: 'order/add',
    order_edit: 'order/edit',
    order_approve: 'order/approve',
    stock_approve: 'sampleStock/allocation/approve',
    order__reset_approval: 'order/resetStatus',
    export_doctor_calender_rx_list: 'prescription/exportDoctorRxCalendar',
    export_doctor_coverage_market_list: 'doctor/exportCoverageByMarket',
    export_market_rx_report: 'prescription/exportMarketRxCalendar',
    market_rx_calender: 'prescription/web/marketRxCalendar',
    rx_comparison: 'prescription/compareWithLastMonth',
    monthly_market_rx_count: 'prescription/monthlyMarketRxCount',
    monthly_market_rx_count_summary: 'prescription/monthlyMarketRxCountSummary',
    monthly_market_rx_count_export: 'prescription/monthlyMarketRxCount/export',
    monthly_market_product_rx_count: 'prescription/monthlyMarketProductRxCount',
    monthly_market_product_rx_count_summary: 'prescription/monthlyMarketProductRxCountSummary',
    monthly_market_product_rx_count_export: 'prescription/monthlyMarketProductRxCount/export',
    market_rx_calendar_summary: 'prescription/marketRxCalendarSummary',
    market_prescriber_calender: 'prescription/web/marketPrescriberCalendar',
    market_prescriber_calender_report: 'prescription/web/marketPrescriberCalendar',
    export_market_prescriber_calender: 'prescription/exportMarketPrescriberCalendar',
    doctor_coverage_market_list: 'doctor/coverageByMarket',
    rx_target_report_list: 'prescription/orion/rxTargetReport',
    export_rx_target_report_list: 'prescription/orion/exportRxTargetReport',
    exportMonthlyTaDaAndMileageOfUser_list: 'expenseClaim/exportMonthlyTaDaAndMileageOfUser',
    export_user_calender_rx_list: 'prescription/exportUserRxCalendar',
    export_product_calender_rx_list: 'prescription/exportProductRxCalendar',
    export_product_brand_calender_rx_list: 'prescription/exportProductBrandRxCalendar',
    export_user_brand_rx_list: 'prescription/exportUserBrandRxReport',
    export_user_doctor_brand_report: 'doctorVisit/exportUserDoctorBrandReport',
    export_doctor_brand_rx_list: 'prescription/exportDoctorBrandRxReport',
    export_market_brand_rx_list: 'prescription/exportMarketBrandRxCalendar',
    export_doctor_calender_dcr_list: 'doctorVisit/exportDoctorDcrCalendar',
    export_user_calender_dcr_list: 'doctorVisit/exportUserDcrCalendar',
    export_product_calender_dcr_list: 'doctorVisit/exportProductDcrCalendar',
    export_product_brand_calender_dcr_list: 'doctorVisit/exportProductBrandDcrCalendar',
    export_order_detail_report: 'order/exportDetailedOrderReport',
    sample_allocation_report: 'sampleStock/allocationOpeningClosingReport',
    sample_allocation_usage_report: 'sampleStock/usageReport',
    product_wise_sample_allocation_report: 'sampleStock/productWiseAllocationOpeningClosingReport',
    sample_transactions: 'sampleStock/transactions',
    export_sample_allocation_report: 'sampleStock/exportAllocationOpeningClosingReport',
    export_product_wise_sample_allocation_report: 'sampleStock/exportProductWiseAllocationOpeningClosingReport',
    export_order_summary_chemist: 'order/exportOrderSummaryByChemist',
    export_order_summary_product: 'order/exportOrderSummaryByProduct',
    export_doctor_visit_list: 'doctorVisit/exportDcrList',
    doctor_call_plan: 'doctorVisitPlan/doctorCallPlanReport',
    doctor_product_call_plan: 'doctorVisitPlan/doctorProductCallPlan',
    export_doctor_product_call_plan: 'doctorVisitPlan/exportDoctorProductCallPlan',
    export_doctor_call_plan: 'doctorVisitPlan/exportDoctorCallPlan',
    campaign_list: 'campaign/list',
    campaign_details: 'campaign',
    campaign_add: 'campaign/add',
    campaign_edit: 'campaign/edit',
    doctor_visit_plan_list: 'doctorVisitPlan/list',
    doctor_visit_plan_user_list: 'doctorVisitPlan/plannedUserList',
    doctor_visit_plan_details: 'doctorVisitPlan',
    doctor_visit_plan_approve: 'doctorVisitPlan/approve',
    order_report_detail: 'order/detailedOrderReport',
    order_report_chemist: 'order/orderSummaryByChemist',
    order_report_product: 'order/orderSummaryByProduct',
    ordered_quantity_report_for_user: 'order/orderedQuantityReport',
    ordered_quantity_report_export: 'order/exportOrderedQuantityReport',
    focus_brand_list: 'focusBrand/activeFocusBrands',
    focus_brand_edit: 'focusBrand/edit',
    focus_brand_add: 'focusBrand/add',
    delete_focus_brand: 'focusBrand',
    focus_brand_details: 'focusBrand/activeFocusBrands',
    market_speciality_wise_count: 'doctor/marketSpecialityWiseCount',
    export_market_speciality_wise_count: 'doctor/exportMarketSpecialityWiseCount',
    doctor_visit_count_by_user: 'doctorVisit/report/doctorVisitCountByUser',
    export_doctor_visit_count_by_user: 'doctorVisit/report/doctorVisitCountByUser/export',
    doctor_market_wise_visit_monitoring: 'doctorVisit/report/doctorMarketWiseVisitMonitoring',
    export_doctor_market_wise_visit_monitoring: 'doctorVisit/report/exportDoctorMarketWiseVisitMonitoring',
    user_wise_doctor_count_report: 'doctor/userWiseCount',
    export_user_wise_doctor_count_report: 'doctor/userWiseCount/export',


    // exam
    exam_list_v2: 'exam/list/underMe',
    exam_create: 'exam/create',
    exam_update: 'exam/update',
    exam_info: 'exam/info',
    set_questions: 'exam/setQuestions',
    question_info: 'exam/questionPaper',
    attended_absent_passed_count: 'result/attendedAbsentPassedCount',
    attended_user_result: 'result/attendedUsers',
    attended_user_result_export: 'result/attendedUsers/export',
    absent_user_result: 'result/absentUsers',
    exam_answer_paper: 'result/answerPaper',
    evaluate_exam: 'exam/evaluate',

    // due report
    due_report_list: 'user/dueReport',
    due_report_export: 'user/exportDueReport',

    // tour plan report
    tour_plan_user_wise_monthly_report: 'tourPlan/userWiseMonthlyReport',
    export_tour_plan_user_wise_monthly_report: 'tourPlan/exportUserWiseMonthlyReport',

    // invoice report
    sharif_sales_report_on_tp: 'invoice/sharif/salesReportOnTp',
    sharif_sales_report_on_tp_export: 'invoice/sharif/exportSalesReportOnTp',
    sharif_sales_report_on_tp_plus_vat: 'invoice/sharif/salesReportOnTpPlusVat',
    sharif_sales_report_on_tp_plus_vat_export: 'invoice/sharif/exportSalesReportOnTpPlusVat',
    sharif_sales_report_on_tp_compare: 'invoice/sharif/salesReportOnTpCompare',
    sharif_sales_report_on_tp_compare_export: 'invoice/sharif/exportSalesReportOnTpCompare',
    user_wise_product_sales: 'invoice/sharif/userProductWiseSales',
    user_wise_product_sales_metadata: 'invoice/sharif/userProductWiseSales/metadata',
    user_wise_product_sales_metadata_export: 'invoice/sharif/exportUserProductWiseSales',
    user_wise_product_sales_compare: 'invoice/sharif/userProductWiseSalesCompare',
    user_wise_product_sales_compare_export: 'invoice/sharif/exportUserProductWiseSalesCompare',

    // doctor service
    doctor_service_approval_rule_list: 'doctorServiceApprovalRule/list',
    doctor_service_approval_rule_add: 'doctorServiceApprovalRule/add',
    doctor_service_approval_rule_delete: 'doctorServiceApprovalRule',
    doctor_service_proposal_type_list: 'doctorServiceProposalType/list',
    doctor_service_proposal_type_add: 'doctorServiceProposalType/add',
    doctor_service_proposal_type_update: 'doctorServiceProposalType/edit',
    doctor_payment_method_list : 'doctorPaymentMethod/list',
    doctor_payment_method_add : 'doctorPaymentMethod/add',
    doctor_payment_method_update : 'doctorPaymentMethod/edit',

    doctor_service_proposal_list: 'doctorServiceProposal/list',
    doctor_service_proposal_detail: 'doctorServiceProposal/detail',
    doctor_service_status_change: 'doctorServiceProposal/approve',

    // patient
    patient_list: 'api/patients/search/advanced',
    patient_manage: 'api/patients',
    patient_details: 'api/patients',
    patient_search: 'api/patients/search',
    patient_rx_order_add: 'api/v1/rx/add',
    patient_rx_order_edit: 'api/v1/rx/edit',
    patient_rx_order_list: 'api/v1/rx/list',
    patient_rx_order_details: 'api/v1/rx/details',
    depot_list: 'api/v1/depot/list',
    follow_up_patient: 'api/follow-ups/patient',
    top_chart_of_list: 'api/v1/rx/top-chart-of-list',
    running_out_of_drugs_patient_list: 'api/patient-product/get-patients-running-out-of-drugs',
    export_running_out_of_drugs_patient_list: 'api/patient-product/get-patients-running-out-of-drugs/export',
    patient_and_product_directory: 'api/patient-product/get-product-and-patient-directory',
    export_patient_and_product_directory: 'api/patient-product/get-product-and-patient-directory/export',
    invoice_bulk_upload_for_patient: 'api/v1/rx/upload',


    // patient dashboard
    patient_dashboard_summary: 'api/v1/rx/top-chart-of-list',
    depot_wise_patient_invoice_summary: 'api/v1/rx/dashboard/get-depot-wise-patient-invoice-summary',
    running_out_of_drugs_patients_number: 'api/patient-product/get-number-of-patients-running-out-of-drugs',

    // weekend
    weekend_request_edit: 'api/weekendRequest/editWeekendRequest',
    weekend_request_details: 'api/weekendRequest/getDetailsById',

};
